// extracted by mini-css-extract-plugin
module.exports = {"logoAd":"VV8EZ","adLogoText":"GtLVe","leftAlign":"Rw0kS"};